import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { AppService } from 'src/app/app.service';
import { DialogsService } from 'src/app/_services/dialogs.service';
import { OrderService } from 'src/app/_services/order.service';

import * as _ from 'lodash';
import {OrderLoyaltyService} from "../order-loyalty/order-loyalty.service";

@Component({
    selector: 'app-tabit-order-tip',
    templateUrl: './tabit-order-tip.component.html',
    styleUrl: './tabit-order-tip.component.scss',
    standalone: false
})
export class TabitOrderTipComponent implements OnInit {
	@Input() public data;
	@Output() onNext = new EventEmitter<any>();
	$storage;
	tipOptions;

	total: number;
	gratuity: any;
	roundPrecision = 0;
	currencyFormat = '1.2-2';

	constructor(
		public app: AppService,
		public dialogsService: DialogsService,
		public orderService: OrderService,
		public loyaltyService: OrderLoyaltyService,
	) {
		this.$storage = this.orderService.$storage;
		if (this.$storage.loyalty?.loyaltyData?.pointsUsed) {
			this.$storage.loyalty.loyaltyData.pointsUsed = 0;
			this.orderService.calculateBasketTotal();
		}

		this.total = this.$storage.order.grandTotalAfterTax;
		this.tipOptions = this.$storage.tipOptions;
		this.gratuity = { type: "x", amount: 0 };

		if (this.tipOptions) {

			let currencyDenom = _.get(this.$storage.currencySettings, 'minimalTipDenomination', 100);
			switch (currencyDenom) {
				case 1:
					this.roundPrecision = 2;
					this.currencyFormat = '1.2-2';
					break;
				case 10:
					this.roundPrecision = 1;
					this.currencyFormat = '1.1-1';
					break;
			}

			if (this.$storage.gratuity) {
				this.gratuity = this.$storage.gratuity;
				delete this.$storage.gratuity;
				this.orderService.calculateBasketTotal();
			}
			const defaultTip = this.tipOptions.defaultValue;
			if (this.tipOptions.valueType == 'percent') {
				this.setGratuity('p', defaultTip);
			} else {
				this.setFixedValGratuity(defaultTip);
			}
		}
		this.calculatePoints();

	}

	ngOnInit(ev?) { }

	continue(withoutGratuity?) {
		if (this.$storage.tipOptions) {
			let gratuity = this.gratuity;
			if (!gratuity.amount && this.app.regionArgs.promptOnNoTip && !withoutGratuity) {
				return this.app.confirm({
					content: 'MESSAGES.CONTINUE_WITHOUT_GRATUITY',
					confirmText: this.app.region == 'US' || this.app.region == 'AU' ? 'yes' : 'CONTINUE_WITHOUT_GRATUITY',
					cancelText: this.app.region == 'US' || this.app.region == 'AU' ? 'no' : "back",
					enlargeTextButtons: true
				}).then(res => {
					this.continue(true);
				}).catch(err => {
				});
			}

			switch (gratuity.type) {
				case "mm": //fixed amount
					gratuity.percent = gratuity.amount / this.total * 100
					break;
				case "m"://manual gratuity
					var amount = gratuity.amount;
					if (isNaN(amount) || amount == 0) {
						gratuity.type == 'c';
						gratuity.amount = 0;
						gratuity.percent = 0;
					} else {
						gratuity.percent = gratuity.amount / this.total * 100
					}
					break;
				case "c":
					gratuity.amount = 0;
					gratuity.percent = 0;
					break;
			}

			this.$storage.gratuity = gratuity;
			this.orderService.calculateBasketTotal();
		}

		if (this.pointsBalance.used) {
			this.$storage.loyalty.loyaltyData.pointsUsed = this.pointsBalance.used;
			this.orderService.calculateBasketTotal();
		}
		this.onNext.emit({});
	}


	slectedGratuity;
	setManualGratuity(mode) {
		if (this.slectedGratuity == mode) {
			this.clearGratuity();
			return;;
		}
		let amount = this.gratuity.type == 'm' && this.gratuity.amount || 0;
		let maxVal = this.$storage.order.total * 2;
		if (!maxVal || maxVal <= 50) maxVal = 200;

		let args = {
			title: 'GRATUITY_AMOUNT',
			currency: this.app.currency,
			maxVal: maxVal,
			response: { amount: amount, amountText: amount + "" },
			enableDecimals: this.app.regionArgs.enableDecimals
		}
		if (mode == 'p') {
			args = {
				...args,
				...{
					title: 'GRATUITY_PERCENT',
					currency: '%',
					maxVal: 200
				}
			}
		}
		this.dialogsService.showKeypadDialog(args).then(response => {
			if (response) {
				let val = response["amount"]
				if (mode == 'p') {
					this.setGratuity('p', val);
				} else {
					this.setValGratuity(val);
				}
				this.slectedGratuity = mode;
			}
		})
	}

	setGratuity(_type, pVal) {
		if (this.slectedGratuity == pVal) {
			this.clearGratuity();
			return;
		}
		this.slectedGratuity = pVal;
		this.gratuity.type = _type;
		this.gratuity.percent = pVal;
		if (_type === 'n') {
			this.gratuity.amount = 0;
		} else if (!isNaN(pVal)) {
			this.gratuity.amount = this.calculateGratuityFromPercent(pVal);
		} else {
			delete this.gratuity.percent;
			delete this.gratuity.amount;
		}
	};

	setFixedValGratuity(val) {
		if (this.slectedGratuity == val) {
			this.clearGratuity();
			return;;
		}
		this.slectedGratuity = val;
		const total = this.total;
		let gratuity = this.gratuity;
		gratuity.type = 'mm';

		gratuity.amount = val;
		gratuity.percent = val / total * 100;;
	}

	setValGratuity(val) {
		const total = this.total;
		let gratuity = this.gratuity;
		gratuity.type = 'm';
		gratuity.amount = val;
		gratuity.percent = val / total * 100;
	}

	clearGratuity() {
		this.slectedGratuity = null;
		this.gratuity = { type: "x", amount: 0 };
	}

	calculateGratuityFromPercent(val) {
		return this.orderService.calculateGratuityFromPercent(val);
	}

	// ------------------------------------------------------------------>
	// ------------------------------------------------------------------>
	// ------------------------------------------------------------------>

	pointsBalance = {
		max: 0,
		used: 0,
		shake: true,
	}

	calculatePoints() {
		if (this.loyaltyService.loyaltyData?.pointsUsable && this.$storage.order.grandTotal) {
			let pointsBalance = _.get(this.loyaltyService.loyaltyData, 'pontsBalance', 0);
			let remainningPayment = this.$storage.order.grandTotalBeforeTax;
			this.pointsBalance.max = Math.min(remainningPayment, pointsBalance);
		}
	}

	getLoyaltyPoints() {
		this.pointsBalance.shake = false;
		this.dialogsService.openLoyaltyPoints({pointsUsed: this.pointsBalance.used}).then(result => {
			if (result) {
				let amount = _.get(result, 'amount', 0);
				this.pointsBalance.used = amount;
			}
		});
	}


}
